import { SxProps } from '@mui/material'
import { modalClasses } from './Modal.data'

interface ModalStyles {
  modal: SxProps
  container: SxProps
  backdrop: SxProps
  header: SxProps
  crossIcon: SxProps
  headerWithoutIcon: SxProps
  title: SxProps
  description: SxProps
}
export const modalDimensions = {
  padding: 3,
}
export const modalStyles: ModalStyles = {
  backdrop: {
    backdropFilter: 'blur(8px)',
    backgroundColor: 'utils.gray950',
    opacity: '0.7 !important', // to override inline opacity we're using !important
  },

  modal: {
    position: 'absolute',
    top: {
      md: '50%',
    },
    bottom: { xs: 0, md: 'auto' },
    left: {
      md: '50%',
      xs: '0%',
    },
    transform: 'translate(-50%, -50%)',
    p: modalDimensions.padding,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    borderBottomLeftRadius: { xs: 0, md: 12 },
    borderBottomRightRadius: { xs: 0, md: 12 },
  },
  container: {
    backgroundColor: 'background.default',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    outline: 'none',
    maxHeight: { xs: '70svh', md: 'initial' },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerWithoutIcon: {
    justifyContent: 'flex-end',

    [`.${modalClasses.titleOnTop} &`]: {
      justifyContent: 'space-between',
    },
  },
  crossIcon: {
    width: 44, //icon container width
    height: 44, //icon container height
    marginTop: -1, //8 multiple using mui spacing factor
    marginRight: -1, //8 multiple using mui spacing factor
    [`.crossIcon`]: {
      width: 24, //icon width
      height: 'auto',
      color: 'action.disabled',
    },
  },
  title: {
    color: 'text.primary900',
    typography: 'textLgSemibold',
  },
  description: {
    color: 'text.secondary700',
    typography: 'textSm',
  },
}
